import { inject } from '@angular/core';
import { IsEditableGuardService } from './is-editable-guard.service';
import { ActivatedRouteSnapshot } from '@angular/router';

export const isEditableGuard = (activatedRoute: ActivatedRouteSnapshot) => {
    const isEditableGuardService = inject(IsEditableGuardService);

    return isEditableGuardService.canActivate(activatedRoute);
};
